class LipscoreController extends AbstractIntegrationController
	@register()
	@inject 'configuration'

	integrationId: 'lipscore'

	save: ->
		if @configuration.api_secret == ''
			delete @configuration.api_secret

		super(@configuration).then =>
			@configuration.is_active = true

	afterDisconnect: ->
		@configuration =
			is_active: false
